[
  "DDR3",
  "DDR4",
  "DDR5",
  "SODIMM",
  "DIMM",
  "ECC",
  "UDIMM",
  "RDIMM",
  "LRDIMM"
]
